import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@siftscience/focus-components/button'
import { Title } from '@siftscience/focus-components/text'
import { Link } from '@siftscience/focus-components/icons/Link'
import { ChevronDown } from '@siftscience/focus-components/icons/ChevronDown'
import { ChevronUp } from '@siftscience/focus-components/icons/ChevronUp'
import LinkedCard from './LinkedCard'
import axios from '../../../utils/http/axios-local'
import { DisputeDTO } from '../dtos'

const useStyles = makeStyles(() => ({
  container: {
    width: '312px',
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
}))

interface IProps {
  items: Record<string, string>[]
  portalId: number
  merchantId: number
}

const LinedCase = ({
  items,
  portalId,
  merchantId
}: IProps): React.ReactElement => {
  const classes = useStyles()
  const [showList, setShowList] = useState(true)
  const [enrichedItems, setEnrichedItems] = useState([])

  useEffect(() => {
    const fetchStatuses = async (): Promise<void> => {
      const promises = items.map(item =>
        axios.get<DisputeDTO>('/det/disputes/lookup', {
          params: {
            portal_id: portalId,
            merchant_id: merchantId,
            case_number: item.case_number,
            reference_number: item.reference_number
          }
        })
      )
      try {
        const results = await Promise.all(promises)
        const newEnrichedItems = results.map(
          (result, index): Record<string, string> => {
            const originalItem = items[index]
            if (!result?.data) return originalItem

            return {
              ...originalItem,
              lifecycle_status: result.data.lifecycleStatus
            }
          }
        )
        setEnrichedItems(newEnrichedItems)
      } catch (error) {
        console.error('Error fetching linked case statuses:', error)
      }
    }

    if (items.length > 0) {
      fetchStatuses()
    }
  }, [items])

  return (
    <div className={classes.container}>
      <Button
        onClick={() => setShowList(prev => !prev)}
        className={classes.button}
        lined={true}
        size="medium"
        variant="secondary"
      >
        <Link />
        <Title size="xsmall">Link Document</Title>
        {showList ? <ChevronDown /> : <ChevronUp />}
      </Button>
      {showList && enrichedItems.length && (
        <div className={classes.list}>
          {enrichedItems.map(
            (item): React.ReactElement => (
              <LinkedCard item={item} key={item.case_number} />
            )
          )}
        </div>
      )}
    </div>
  )
}

export default LinedCase
